module.exports = __webpack_public_path__ + "img/00020.94b31b4d.webp";